import { TRIGGER_HIDE_TOOLTIP_MESSAGES_EVENT } from '@components/TooltipComponent/CONSTANTS';
import { DATA_TRANSLATE_ATTRIBUTE } from '@core/constants/ATTRIBUTES';
import { showNotification } from './notification-messages';
import { translate } from '@core/i18n/window-language';
import { NOTIFICATIONS_TYPE } from '@core/constants/NOTIFICATIONS';
import { getWesogUserInfo } from './wesog-user';
import { ENDPOINT_DOWNLOAD_OPTIONS } from '@core/constants/API';

/**
 * Add the download options list.
 * @param {object} _this - The current object.
 * @param {Array<object>} options - The options to add.
 * @param {string} reference - The reference.
 * @returns {void}
 */
export const addDownloadOptionsList = (_this, options, reference) => {
    const optionContainer = _this.shadowRoot.querySelector('.options-download-modal');
    const /** @type {HTMLUListElement} */ ul = optionContainer.querySelector('ul');
    ul.innerHTML = '';

    options.forEach((option) => {
        const /** @type {HTMLLIElement} */ li = document.createElement('li');
        li.setAttribute('value', option.name);
        li.setAttribute('code', option.code);

        const /** @type {HTMLSpanElement} */ spanText = document.createElement('span');
        spanText.setAttribute(
            DATA_TRANSLATE_ATTRIBUTE,
            `downloads.options.${option.name.replace(' ', '')}`,
        );

        spanText.classList.add('label-small');

        li.appendChild(spanText);

        li.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            downloadActive(option.code, reference);
            optionContainer.style.display = 'none';
        });

        ul.appendChild(li);
    });
    optionContainer.style.display = 'flex';

    const /** @type {HTMLDivElement} */ overlay =
            _this.shadowRoot.querySelector('.overlay');
    overlay.classList.remove('hidden-overlay');
    overlay.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        optionContainer.style.display = 'none';
        overlay.classList.add('hidden-overlay');
    });

    _this.shadowRoot
        .querySelector('[data-close-options-download]')
        ?.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            optionContainer.style.display = 'none';
            overlay.classList.add('hidden-overlay');
        });

    document.dispatchEvent(new CustomEvent(TRIGGER_HIDE_TOOLTIP_MESSAGES_EVENT));
};

/**
 * Download the active element.
 * @param {string} code
 * @returns {void}
 */
export const downloadActive = (code, reference) => {
    try {
        downloadItem(code, reference);
    } catch (error) {
        console.error('Error download element', error);

        showNotification(
            translate('notification.errors.downloadElementError'),
            NOTIFICATIONS_TYPE.ERROR,
        );
    }
};

/**
 * Download the item.
 * @param {string} code - The code.
 * @returns {void}
 */
export const downloadItem = (code) => {
    /** @type {{ username: string, access_token: string, searcherHistory: string, lastName: string, email: string, id: string, language: string, phone: string, pseudo: string}} */
    const user = getWesogUserInfo();

    let /** @type {string} */ url = `${ENDPOINT_DOWNLOAD_OPTIONS}/${user.access_token}/${code}`;

    const /** @type {HTMLAnchorElement} */ a = document.createElement('a');
    a.href = url;
    a.download;
    a.click();

    a.remove();
};
